export const mainLoomVideoUrl =
  "https://www.loom.com/share/e19ddbea1c3142eda81e4249e4994aa3";
export const companyLoomVideoUrl = mainLoomVideoUrl;
